var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.083 25.083-1.5-1.5L20 14.167l9.417 9.375-1.5 1.5L20 17.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandLess);
export default __webpack_public_path__ + "static/media/icon-expand-less.39a445ce02a496003b8e9c9d5a5a62a4.svg";
export { ForwardRef as ReactComponent };